module.exports = __webpack_public_path__ + "static/media/4en.26cf32c2.jpg";